import './App.css';

import React from 'react'
import {
 BrowserRouter as Router,
 Routes,
 Route
} from "react-router-dom";

import LangRoute from './components/LangRoute'
import LangRedirect from './components/LangRedirect'

import MainPage from './containers/MainPage'
import SolutionPage from './containers/SolutionPage'
import TechPage from './containers/TechPage'
import GeneralPage from './containers/GeneralPage'
import StoryPage from './containers/StoryPage'
import BlogPage from './containers/BlogPage'
import ContactUsPage from './containers/ContactUsPage'
import CoreTechnologyPage from './containers/CoreTechnologyPage'
import CareersPage from './containers/CareersPage'
import JobDetailPage from './containers/JobDetailPage'
import AboutUsPage from './containers/AboutUsPage'
import CollaboratePage from './containers/CollaboratePage'

function App() {
  return (
    <div className="App">
      <Router>
        <main><Routes>
          {/* Language-prefixed routes */}
          <Route path="/:lang/" element={<LangRoute component={MainPage} />} />
          <Route path="/:lang/home" element={<LangRoute component={MainPage} />} />
          <Route path="/:lang/about/about_us" element={<LangRoute component={AboutUsPage} />} />
          <Route path="/:lang/about/colab_flow" element={<LangRoute component={CollaboratePage} />} />
          <Route path="/:lang/about/career" element={<LangRoute component={CareersPage} />} />
          <Route path="/:lang/about/intern" element={<LangRoute component={CareersPage} />} />
          <Route path="/:lang/about/environment" element={<LangRoute component={CareersPage} />} />
          <Route path="/:lang/about/SE-robot" element={<LangRoute component={JobDetailPage} />} />
          <Route path="/:lang/about/SE" element={<LangRoute component={JobDetailPage} />} />
          <Route path="/:lang/about/SD" element={<LangRoute component={JobDetailPage} />} />
          <Route path="/:lang/about/HW-robot" element={<LangRoute component={JobDetailPage} />} />
          <Route path="/:lang/about/softwareIntern" element={<LangRoute component={JobDetailPage} />} />
          <Route path="/:lang/about/hardwareIntern" element={<LangRoute component={JobDetailPage} />} />
          <Route path="/:lang/about/:page" element={<LangRoute component={GeneralPage} />} />
          <Route path="/:lang/tech/:page" element={<LangRoute component={TechPage} />} />
          <Route path="/:lang/solutions" element={<LangRoute component={SolutionPage} />} />
          <Route path="/:lang/contact" element={<LangRoute component={ContactUsPage} />} />
          <Route path="/:lang/stories" element={<LangRoute component={StoryPage} />} />
          <Route path="/:lang/blog" element={<LangRoute component={BlogPage} />} />
          <Route path="/:lang/core-technology" element={<LangRoute component={CoreTechnologyPage} />} />

          {/* Old routes redirect to new paths */}
          <Route path="/MainPage" element={<LangRedirect />} />
          <Route path="/SolutionPage" element={<LangRedirect />} />
          <Route path="/ContactUsPage" element={<LangRedirect />} />
          <Route path="/StoryPage" element={<LangRedirect />} />
          <Route path="/BlogPage" element={<LangRedirect />} />
          <Route path="/GeneralPage" element={<LangRedirect />} />
          <Route path="/TechPage" element={<LangRedirect />} />

          {/* Root redirect */}
          <Route path="/" element={<LangRedirect />} />

          {/* Catch-all */}
          <Route path="*" element={<LangRedirect />} />
        </Routes></main>
      </Router>
    </div>
  );
}

export default App;
